var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 22.4,
    height: 26.88,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 158.406h141.598V55.203H12Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 158.406h141.598V55.203H12Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.23 55.203H23.371c-6.277.004-11.367 5.164-11.371 11.531v80.141a11.48 11.48 0 0 0 3.516 8.328v.008h.003l.004.004a11.234 11.234 0 0 0 7.848 3.191H142.23a11.214 11.214 0 0 0 7.907-3.25h.004l.004-.008a11.505 11.505 0 0 0 3.453-8.273v-80.14c-.004-6.368-5.094-11.528-11.368-11.532ZM23.371 60.61h118.856c.57 0 1.136.075 1.683.235l-44.86 42.355-14.39-13.543a2.644 2.644 0 0 0-3.629 0l-14.433 13.582L21.69 60.844a5.933 5.933 0 0 1 1.68-.235zm-6.047 86.266v-80.14c0-.766.14-1.524.414-2.235l44.942 42.422-44.914 42.266a6.326 6.326 0 0 1-.442-2.313zm124.906 6.129H23.371a6.21 6.21 0 0 1-1.59-.223l61.063-57.46 61.051 57.441a6.008 6.008 0 0 1-1.665.242zm6.04-6.129a6.205 6.205 0 0 1-.415 2.242l-44.89-42.234L147.859 64.5c.27.71.414 1.469.411 2.234z",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(22.4 0 0 26.88 0 0)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABUCAYAAAA/MEEUAAAABHNCSVQICAgIfAhkiAAAAL5JREFUeJzt0MENwCAQwLDS/Xc+BkB5w8OeIMqamfk4/LcDXmVMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCYYE4wJxgRjgjHBmGBMMCZsCdAEpPILOpwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.13333 0 0 -.13333 0 26.88)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(168 0 0 -201.6 0 201.6)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABUCAYAAAA/MEEUAAAABHNCSVQICAgIfAhkiAAAAMlJREFUeJzt3LENgDAMAEEHsf/KYQDyNRR3E1gvF668ZmYPL9fXA/yVMEGYIEwQJggThAn33s6YExsThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIEwQJggThAnCBGGCMEGYIExY4w/ekY0JwgRhgjBBmCBMECYIE4QJwgRhwgN/6QWkaMof1AAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(.13333 0 0 -.13333 0 26.88)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1,
    height: 1,
    style: {
      imageRendering: "optimizeSpeed"
    },
    preserveAspectRatio: "none",
    transform: "matrix(168 0 0 -201.6 0 201.6)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABUCAYAAAA/MEEUAAAABHNCSVQICAgIfAhkiAAAAMxJREFUeJzt3LENgEAMBEGDCL7/dgmgANgYgpkKrNXF3mbmGh72rw/4K2GCMEGYIEwQJggTjnOtr2/4JYsJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECYIE4QJwgRhgjBBmCBMECZs4w/eK4sJwgRhgjBBmCBMECYIE4QJwgRhwg0zKgOyBoXZugAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail2);
export default __webpack_public_path__ + "static/media/email2.5e6bfe4eeceb197be7db7ba37d3920c1.svg";
export { ForwardRef as ReactComponent };